import {Component} from "@angular/core";

@Component({
  selector: 'premium-page',
  template: require('./premium-page.component.html'),
  styles: [
    require('./premium-page.component.scss')
  ]
})

export class PremiumPageComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/premium/premium-page.component.ts